import React from 'react';
import DOWNLOAD from '../build/images/botaodownload.png'
import { DownloadFile } from '../actions'
import { connect } from 'react-redux'
const { connection_platform } = require("../services/api")

var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern
var port = connection_platform.port_backend_intern;

if(gethostname === 'localhost')
  pathname = iplocal;
else
  pathname = gethostname;

var ipcurrent = pathname;

if(pathname !== connection_platform.ip_intern){
    ipcurrent = connection_platform.ip_apache_view_extern;
    if(parseInt(connection_platform.port_apache_view_extern) !== 80){
        ipcurrent = ipcurrent+':'+connection_platform.port_apache_view_extern;
    }
}else{
    ipcurrent = connection_platform.ip_apache_view_intern;
    if(parseInt(connection_platform.port_apache_view_intern) !== 80){
        ipcurrent = ipcurrent+':'+connection_platform.port_apache_view_intern;
    }
}

const mapDispatchToProps = dispatch => ({
  DownloadFile: (post,temp) => {
    dispatch(DownloadFile(post,temp))
  },
})

class Native extends React.Component {

  componentDidMount(){
    this.props.DownloadFile(connection_platform.type_connect+'://'+ipcurrent+'/native/WebPhoneService_Install.exe','WebPhoneService_Install.exe')
  }

  download(){
    this.props.DownloadFile(connection_platform.type_connect+'://'+ipcurrent+'/native/WebPhoneService_Install.exe','WebPhoneService_Install.exe')
  }

  render() {
      return (
        <div style={{display:'inline-block',textAlign:'center', cursor: 'pointer'}} onClick={event => this.download(event)}>
          <h5>Se você foi direcionado para esta tela significa que, ou ainda não foi instalado o plugin ou seu computador está com uma versão desatualizada.</h5>
          <h4>Caso não inicie automaticamente, clique no botão de download abaixo</h4>
          <img src={DOWNLOAD} alt="" />
        </div>
      );
  }
}

export default connect(
  null,
  mapDispatchToProps
)(Native);